<template>
  <div class="container">
    <div class="title">
      {{ poiName }}
    </div>
    <ServiceLevelCard
      v-if="gotServiceLevel"
      :service-level-info="serviceLevelInfo"
    />
    <PoiDetailQuestion />
    <div class="phone-call-container">
      <div
        class="phone-call-btn"
        @click="callPhone"
      >
        <img src="@/assets/img/phone@2x.png" />
        致电业务经理
        <span style="margin-left:0.12rem;">{{ contactBdName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import STATUS from '@/constants/status';
import Store from '@/store/index';
import ServiceLevelApi from '@/api/serviceLevel';
import ContactBdApi from '@/api/contactBd';
import ServiceLevelCard from './components/ServiceLevelCard';
import PoiDetailQuestion from './components/PoiDetailQuestion';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';

export default {
  name: 'ServiceLevelPoiDetail',
  components: {
    ServiceLevelCard,
    PoiDetailQuestion,
  },
  data() {
    return {
      serviceLevelInfo: {
        serviceLevel: 0,
        bizareaRank: 0,
        bizareaRankRatio: '',
        poorServiceCnt: 0,
      },
      showScrollTopBtn: false,
      poiId: '',
      poiName: '',
      contactBdName: '',
      contactBdMis: '',
      gotServiceLevel: false, // 服务等级卡片的背景会提前加载，用于保证能够在获取到服务等级后再显示
      cid: this.$CID.ServiceLevelPoiDetail,
    };
  },
  async mounted() {
    this.init();
    await this.getServiceLevel();
  },
  methods: {
    async getServiceLevel() {
      const partnerId = Store.getters['partnerModule/id'];
      const params = {
        poiId: this.poiId,
        partnerId,
      };
      const { data, error } = await ServiceLevelApi.getPoiServiceLevel(params);
      if (!error && data) {
        this.serviceLevelInfo.serviceLevel = data.lastmonthServiceGrade;
        this.serviceLevelInfo.bizareaRank = data.lastmonthBizareaRank;
        this.serviceLevelInfo.bizareaRankRatio = data.lastmonthBizareaRankRatio;
      }
      this.gotServiceLevel = true;
    },
    init() {
      const {
        poiId, poiName, contactBdName, contactBdMis,
      } = this.$route.query;
      this.poiId = poiId;
      this.poiName = poiName;
      this.contactBdName = contactBdName;
      this.contactBdMis = contactBdMis;
    },
    async callPhone() {
      this.$dialog.loading.show();
      try {
        const { status, data } = await ContactBdApi.getBDPhoneByPoiId(this.poiId, this.contactBdMis);
        if (status !== STATUS.SUCCESS || !data) return;
        window.location.href = `tel:${data}`;
      } catch (e) {
        console.error(e);
      } finally {
        this.$dialog.loading.hide();
      }
      tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_DETAIL_CALL, null, { cid: this.cid });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #F8F8F8;
  height: 100%;
  min-height:100vh;
  padding: 0 0.24rem;
  color: #222;
  text-align:left;
  font-family: "PingFang SC";
  .title{
    font-size: 0.28rem;
    line-height: 0.4rem;
    padding: 0.18rem 0;
  }
  .phone-call-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.8rem;
    background-color: #fff;
    border-radius: 0.24rem 0.24rem 0 0;
    .phone-call-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 6.9rem;
      height:0.8rem;
      margin: 0.3rem auto;
      border-radius: 0.82rem;
      border: 2px solid #999999;
      img {
        width: 0.28rem;
        margin-right: 0.12rem;
      }
    }
  }
}
</style>
